import { gql } from "@apollo/client";

// Raw gql; excluded from codegen in codegen-main.ts.
export const NOTIFICATION_MARK_READ_MUTATION = gql`
  mutation AdminNotificationMarkRead($id: ID!) {
    notificationMarkRead(id: $id) {
      notification {
        id
        isRead
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const NOTIFICATION_MARK_ALL_READ_MUTATION = gql`
  mutation AdminNotificationMarkAllRead {
    notificationMarkAllRead {
      count
      errors {
        field
        message
        code
      }
    }
  }
`;

export const PUSH_DEVICE_REGISTER_MUTATION = gql`
  mutation AdminPushDeviceRegister($token: String!) {
    pushDeviceRegister(token: $token) {
      errors {
        field
        message
        code
      }
    }
  }
`;
